"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_COUNTRY = void 0;
/**
 * The country this customer-facing platform represents. Hardcoded because
 * the platform's identity IS the country — the Sky Lifestyle Botswana bundle
 * always writes "Botswana" to downstream records (loans, lay-buys, etc.),
 * regardless of what the user's credentials say.
 *
 * Used at create time so downstream records carry the platform's country
 * without needing a credentials lookup or dual-active disambiguation.
 *
 * Per-platform values:
 *   - sky_lifestyle_web         → "Namibia"
 *   - sky_lifestyle_botswana_web → "Botswana"
 *   - bravo_tech_web            → "Namibia" (white-label Sky Lifestyle Namibia)
 */
exports.PLATFORM_COUNTRY = "Botswana";
